export default __webpack_public_path__ + "static/media/full-screen.6c0f08c3.svg";